import React, { useEffect, useState } from "react";
import { padalaServices } from "../services/PadalaServices";
import { adminServices } from "../services/AdminServices";
import DataTable from "react-data-table-component";
import { ReactComponent as TransactionIcon } from '../icons/transactions.svg';
import { useNavigate, useLocation } from "react-router-dom";
import LoadingModal from "../components/LoadingModal";
import SearchBar from "../components/SearchBar";
import Button from "../components/Button";
import { formatCurrency } from '../tools/tool';
import InputText1 from "../components/InputText1";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import withAuthorization from "../components/withAuthorization";
import { logExport } from "../services/ExportLogService";
const PadalaReports = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [padalaList, setPadalaList] = useState(null);
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);
  const [grossTotal, setGrossTotal] = useState(0);
  const [interestTotal, setInterestTotal] = useState(0);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [selectedType, setSelectedType] = useState('all');
  useEffect(() => {
    setLoading(true);
    getPadala();
    const params = new URLSearchParams(location.search);
    const typeParam = params.get('type');
    if (typeParam) {
      setSelectedType(typeParam);
    }
  }, [location.search]);
  useEffect(() => {
    filterDataByType();
  }, [data, selectedType]);
  const filterDataByType = () => {
    let filtered = data;
    if (selectedType !== 'all') {
      if (selectedType === 'walk-in') {
        filtered = data.filter(item => item.cash_in_from && item.cash_in_from.toLowerCase().includes('walk'));
      } else if (selectedType === 'icarus') {
        filtered = data.filter(item => item.cash_in_from && (item.cash_in_from.toLowerCase().includes('padala app') || item.cash_in_from.toLowerCase().includes('app')));
      } else if (selectedType === 'ecpay') {
        filtered = data.filter(item => item.cash_in_from && item.cash_in_from.toLowerCase().includes('ecpay'));
      }
    }
    setFilteredData(filtered);
    let gT = filtered.reduce((total, item) => total + (item.net_amount || 0), 0);
    let grossT = filtered.reduce((total, item) => total + (item.gross_amount || 0), 0);
    let interestT = filtered.reduce((total, item) => total + (item.interest_rate || 0), 0);
    setGrandTotal(gT);
    setGrossTotal(grossT);
    setInterestTotal(interestT);
  };
  let columns = [{
    name: 'Transaction Date',
    selector: data => data.reg_date,
    sortable: true,
    defaultSortAsc: false
  }, {
    name: 'PDL Name',
    selector: data => data.pdlName,
    sortable: true
  }, {
    name: 'PDL Number',
    selector: data => data.pdl_number,
    sortable: true
  }, {
    name: 'Net Amount',
    selector: data => formatCurrency(data.net_amount),
    sortable: true,
    right: true,
    headerStyle: {
      textAlign: 'center'
    }
  }, {
    name: 'Interest Amount',
    selector: data => formatCurrency(data.interest_rate),
    sortable: true,
    right: true,
    headerStyle: {
      textAlign: 'center'
    }
  }, {
    name: 'Interest Rate',
    selector: data => data.percent + "%",
    sortable: true,
    right: true,
    headerStyle: {
      textAlign: 'center'
    }
  }, {
    name: 'Gross Amount',
    selector: data => formatCurrency(data.gross_amount),
    sortable: true,
    right: true,
    headerStyle: {
      textAlign: 'center'
    }
  }, {
    name: 'Reference',
    selector: data => data.bank_reference,
    sortable: true
  }, {
    name: 'Sender',
    selector: data => data.sender,
    sortable: true
  }, {
    name: 'Cash In From',
    selector: data => data.cash_in_from,
    sortable: true
  }, {
    name: 'Processed By',
    selector: data => data.processed_by,
    sortable: true
  }];
  const exportToCSV = async data => {
    if (!data || data.length === 0) return;

    // Log the export
    await logExport('Padala Reports');
    const headers = ['Transaction Date', 'PDL Name', 'PDL Number', 'Net Amount', 'Interest Amount', 'Interest Rate', 'Gross Amount', 'Reference', 'Sender', 'Cash In From', 'Processed By'];
    const rows = data.map(row => [row.reg_date, row.pdlName, row.pdl_number, row.net_amount,
    // raw value
    row.interest_rate,
    // raw value
    `${row.percent}%`, row.gross_amount,
    // raw value
    row.bank_reference, row.sender, row.cash_in_from, row.processed_by]);
    const csvContent = [headers, ...rows].map(row => row.map(field => `"${field}"`).join(',')).join('\n');
    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'PadalaReport.csv');
    link.click();
  };
  const getPadala = async () => {
    await adminServices.storeProcedure2('padala_report', {}).then(r => {
      setPadalaList(null);
      setPadalaList(r.data);
      setData(r.data);
      setFilteredData(r.data);
      let gT = r.data.reduce((total, item) => total + (item.net_amount || 0), 0);
      let grossT = r.data.reduce((total, item) => total + (item.gross_amount || 0), 0);
      let interestT = r.data.reduce((total, item) => total + (item.interest_rate || 0), 0);
      setGrandTotal(gT);
      setGrossTotal(grossT);
      setInterestTotal(interestT);
      setLoading(false);
    }).catch(e => {
      if (e.status == 401) {
        window.location.href = '/';
      }
    });
  };
  const PadalaRange = async () => {
    await adminServices.storeProcedure2('padala_report_range', {
      dateFrom: dateFrom,
      dateTo: dateTo
    }).then(r => {
      setPadalaList(null);
      setPadalaList(r.data);
      setData(r.data);
      setFilteredData(r.data);
      let gT = r.data.reduce((total, item) => total + (item.net_amount || 0), 0);
      let grossT = r.data.reduce((total, item) => total + (item.gross_amount || 0), 0);
      let interestT = r.data.reduce((total, item) => total + (item.interest_rate || 0), 0);
      setGrandTotal(gT);
      setGrossTotal(grossT);
      setInterestTotal(interestT);
      setLoading(false);
    }).catch(e => {
      if (e.status == 401) {
        window.location.href = '/';
      }
    });
  };
  return <div>
      <LoadingModal show={loading} message={"Loading Padala Report"} />
      <div style={{
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: 10,
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '20px'
    }}>
          <TransactionIcon style={{
        width: "50px",
        height: "50px",
        marginRight: "10px",
        background: 'transparent'
      }} />
          <span>Padala Report</span>
          <span style={{
        fontSize: '1.2rem',
        marginLeft: '10px'
      }}>Total Net Amount: {formatCurrency(grandTotal)}</span>
          <span style={{
        fontSize: '1.2rem'
      }}>Total Interest Amount: {formatCurrency(interestTotal)}</span>
          <span style={{
        fontSize: '1.2rem'
      }}>Total Gross Amount: {formatCurrency(grossTotal)}</span>
      </div>

      <div className="flexRow" style={{
      width: '50%'
    }}>
          <InputText1 title={"Date From"} type="date" value={dateFrom} onChange={e => {
        setDateFrom(e.target.value);
      }} />

         <InputText1 title={"Date To"} type="date" value={dateTo} onChange={async e => {
        setDateTo(e.target.value);
      }} />

          <div style={{
        marginTop: 18
      }}>
            <Button variant={"primary"} onClick={PadalaRange}>Search</Button>
          </div>

      </div>

      <div className="flexRow">
        <div className="flexRow filterDiv">
          <SearchBar placeholder="Search Padala Report" onChange={e => {
          const value = e.target.value.toLowerCase();
          setSearchQuery(value);
          let baseData = data;
          if (selectedType !== 'all') {
            if (selectedType === 'walk-in') {
              baseData = data.filter(item => item.cash_in_from && item.cash_in_from.toLowerCase().includes('walk'));
            } else if (selectedType === 'icarus') {
              baseData = data.filter(item => item.cash_in_from && (item.cash_in_from.toLowerCase().includes('padala app') || item.cash_in_from.toLowerCase().includes('app')));
            } else if (selectedType === 'ecpay') {
              baseData = data.filter(item => item.cash_in_from && item.cash_in_from.toLowerCase().includes('ecpay'));
            }
          }
          const filtered = baseData.filter(item => Object.keys(item).some(key => item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase())));
          setFilteredData(filtered);
          let gT = filtered.reduce((total, item) => total + (item.net_amount || 0), 0);
          let grossT = filtered.reduce((total, item) => total + (item.gross_amount || 0), 0);
          let interestT = filtered.reduce((total, item) => total + (item.interest_rate || 0), 0);
          setGrandTotal(gT);
          setGrossTotal(grossT);
          setInterestTotal(interestT);
        }} />
          <div style={{
          display: 'flex',
          alignItems: 'center',
          marginLeft: 10
        }}>
            <span style={{
            fontWeight: 'bold',
            marginRight: 8
          }}>Type:</span>
            <select value={selectedType} onChange={e => setSelectedType(e.target.value)} style={{
            padding: '6px 10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            fontSize: '14px',
            minWidth: '150px'
          }}>
              <option value="all">All Types</option>
              <option value="walk-in">Walk-in</option>
              <option value="icarus">Icarus App</option>
              <option value="ecpay">Ecpay</option>
            </select>
          </div>
        </div>
        &nbsp;&nbsp;
        <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end"
      }}>
        </div>
        <div className="spacer"></div>
        <Button variant={"success"} size={'xs'} onClick={() => exportToCSV(filteredData)}> Export to CSV </Button>
      </div>
      
      <br />
      <DataTable columns={columns} data={filteredData} pagination={false} persistTableHead persistTableBody highlightOnHover style={{
      zIndex: 0
    }} defaultSortFieldId="reg_date" />
    </div>;
};
export default withAuthorization(PadalaReports, 4);